import { createContext, useContext, useState } from "react";

const CurCtx = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(
    localStorage.getItem("madymark_currency") || "TRY"
  );
  const change = (c) => {
    setCurrency(c);
    localStorage.setItem("madymark_currency", c);
  };
  return <CurCtx.Provider value={{ currency, setCurrency: change }}>{children}</CurCtx.Provider>;
};

export const useCurrency = () => useContext(CurCtx);
